
import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Edit } from "lucide-react";
import SuggestEditForm from './SuggestEditForm';
import SuggestionInfoPopover from '@/components/SuggestionInfoPopover';
import { SolutionData } from '@/types/solution';

interface SuggestEditDialogProps {
  solution: SolutionData;
  className?: string;
}

const SuggestEditDialog = ({ solution, className }: SuggestEditDialogProps) => {
  const [open, setOpen] = React.useState(false);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button 
          variant="outline" 
          size="sm" 
          className={`gap-1 border-primary text-primary hover:bg-primary/10 hover:text-primary ${className}`}
        >
          <Edit className="h-4 w-4" />
          Edit Page
        </Button>
      </DialogTrigger>
      <DialogContent className="w-[95%] max-w-4xl max-h-[80vh] overflow-y-auto sm:w-[90%] sm:max-w-6xl sm:max-h-[90vh] pb-0">
        <SuggestionInfoPopover className="absolute right-14 top-4" />
        <DialogHeader>
          <DialogTitle>Suggest Edits for {solution.name}</DialogTitle>
        </DialogHeader>
        <SuggestEditForm
          solutionId={solution.id}
          solutionName={solution.name}
          solutionShortDescription={solution.shortDescription}
          solutionTags={solution.tags}
          solutionImage={solution.image}
          solutionDetails={solution.details}
          onSuccess={() => setOpen(false)}
        />
      </DialogContent>
    </Dialog>
  );
};

export default SuggestEditDialog;
